module.exports = __webpack_public_path__ + "static/img/loading-lazy.c17409a8.gif";